"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListMyAccessibleChartsInAnOrgFromHCPPatientWorkListControllerFilterNccnCriteriaEnum = exports.ListMyAccessibleChartsInAnOrgFromHCPPatientWorkListControllerFilterInviteStatusEnum = exports.ListMyAccessibleChartsInAnOrgFromHCPPatientWorkListControllerSortDateAppointmentPretestEnum = exports.DownloadTranscriptPdfByInviteIdFromHCPPatientWorkListControllerResponseTypeEnum = exports.DownloadTranscriptPdfByIdFromHCPPatientWorkListControllerResponseTypeEnum = exports.DownloadReportPdfByInviteIdFromHCPPatientWorkListControllerResponseTypeEnum = exports.DownloadReportPdfByIdFromHCPPatientWorkListControllerResponseTypeEnum = exports.HcpPwlMeApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var HcpPwlMeApi = /** @class */ (function (_super) {
    __extends(HcpPwlMeApi, _super);
    function HcpPwlMeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Checks if each MRN in the array exist in PDS for a given organization
     */
    HcpPwlMeApi.prototype.checkMrnInOrgBulkFromHCPPatientWorkListControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgId === null || requestParameters.orgId === undefined) {
                            throw new runtime.RequiredError('orgId', 'Required parameter requestParameters.orgId was null or undefined when calling checkMrnInOrgBulkFromHCPPatientWorkListController.');
                        }
                        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
                            throw new runtime.RequiredError('requestBody', 'Required parameter requestParameters.requestBody was null or undefined when calling checkMrnInOrgBulkFromHCPPatientWorkListController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/hcp-pwl/me/orgs/{orgId}/check-mrn-bulk".replace("{".concat("orgId", "}"), encodeURIComponent(String(requestParameters.orgId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: requestParameters.requestBody,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * Checks if each MRN in the array exist in PDS for a given organization
     */
    HcpPwlMeApi.prototype.checkMrnInOrgBulkFromHCPPatientWorkListController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.checkMrnInOrgBulkFromHCPPatientWorkListControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates or updates patient chart(s) in PDS, and optionally in additional subsystems
     */
    HcpPwlMeApi.prototype.createOrUpdateChartsInOrgFromHCPPatientWorkListControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgId === null || requestParameters.orgId === undefined) {
                            throw new runtime.RequiredError('orgId', 'Required parameter requestParameters.orgId was null or undefined when calling createOrUpdateChartsInOrgFromHCPPatientWorkListController.');
                        }
                        if (requestParameters.createChartRequestDto === null || requestParameters.createChartRequestDto === undefined) {
                            throw new runtime.RequiredError('createChartRequestDto', 'Required parameter requestParameters.createChartRequestDto was null or undefined when calling createOrUpdateChartsInOrgFromHCPPatientWorkListController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/hcp-pwl/me/orgs/{orgId}/charts".replace("{".concat("orgId", "}"), encodeURIComponent(String(requestParameters.orgId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: requestParameters.createChartRequestDto.map(models_1.CreateChartRequestDtoToJSON),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ChartListBulkDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates or updates patient chart(s) in PDS, and optionally in additional subsystems
     */
    HcpPwlMeApi.prototype.createOrUpdateChartsInOrgFromHCPPatientWorkListController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createOrUpdateChartsInOrgFromHCPPatientWorkListControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates order intent for a given chart and stores to reqrepo`s session
     */
    HcpPwlMeApi.prototype.createOrderIntentForChartFromHCPPatientWorkListControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgId === null || requestParameters.orgId === undefined) {
                            throw new runtime.RequiredError('orgId', 'Required parameter requestParameters.orgId was null or undefined when calling createOrderIntentForChartFromHCPPatientWorkListController.');
                        }
                        if (requestParameters.chartId === null || requestParameters.chartId === undefined) {
                            throw new runtime.RequiredError('chartId', 'Required parameter requestParameters.chartId was null or undefined when calling createOrderIntentForChartFromHCPPatientWorkListController.');
                        }
                        if (requestParameters.createOrderIntentForChartRequestDto === null || requestParameters.createOrderIntentForChartRequestDto === undefined) {
                            throw new runtime.RequiredError('createOrderIntentForChartRequestDto', 'Required parameter requestParameters.createOrderIntentForChartRequestDto was null or undefined when calling createOrderIntentForChartFromHCPPatientWorkListController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/hcp-pwl/me/orgs/{orgId}/charts/{chartId}/order-intents".replace("{".concat("orgId", "}"), encodeURIComponent(String(requestParameters.orgId))).replace("{".concat("chartId", "}"), encodeURIComponent(String(requestParameters.chartId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.CreateOrderIntentForChartRequestDtoToJSON)(requestParameters.createOrderIntentForChartRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Creates order intent for a given chart and stores to reqrepo`s session
     */
    HcpPwlMeApi.prototype.createOrderIntentForChartFromHCPPatientWorkListController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createOrderIntentForChartFromHCPPatientWorkListControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Downloads report pdf by id
     */
    HcpPwlMeApi.prototype.downloadReportPdfByIdFromHCPPatientWorkListControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling downloadReportPdfByIdFromHCPPatientWorkListController.');
                        }
                        queryParameters = {};
                        if (requestParameters.responseType !== undefined) {
                            queryParameters['responseType'] = requestParameters.responseType;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/hcp-pwl/me/reports/{id}/pdf".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Downloads report pdf by id
     */
    HcpPwlMeApi.prototype.downloadReportPdfByIdFromHCPPatientWorkListController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadReportPdfByIdFromHCPPatientWorkListControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Downloads report pdf by invite id
     */
    HcpPwlMeApi.prototype.downloadReportPdfByInviteIdFromHCPPatientWorkListControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.inviteId === null || requestParameters.inviteId === undefined) {
                            throw new runtime.RequiredError('inviteId', 'Required parameter requestParameters.inviteId was null or undefined when calling downloadReportPdfByInviteIdFromHCPPatientWorkListController.');
                        }
                        queryParameters = {};
                        if (requestParameters.responseType !== undefined) {
                            queryParameters['responseType'] = requestParameters.responseType;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/hcp-pwl/me/invites/{inviteId}/report/pdf".replace("{".concat("inviteId", "}"), encodeURIComponent(String(requestParameters.inviteId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Downloads report pdf by invite id
     */
    HcpPwlMeApi.prototype.downloadReportPdfByInviteIdFromHCPPatientWorkListController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadReportPdfByInviteIdFromHCPPatientWorkListControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Downloads transcript pdf by id
     */
    HcpPwlMeApi.prototype.downloadTranscriptPdfByIdFromHCPPatientWorkListControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling downloadTranscriptPdfByIdFromHCPPatientWorkListController.');
                        }
                        queryParameters = {};
                        if (requestParameters.responseType !== undefined) {
                            queryParameters['responseType'] = requestParameters.responseType;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/hcp-pwl/me/transcripts/{id}/pdf".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Downloads transcript pdf by id
     */
    HcpPwlMeApi.prototype.downloadTranscriptPdfByIdFromHCPPatientWorkListController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadTranscriptPdfByIdFromHCPPatientWorkListControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Downloads transcript pdf by invite id
     */
    HcpPwlMeApi.prototype.downloadTranscriptPdfByInviteIdFromHCPPatientWorkListControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.inviteId === null || requestParameters.inviteId === undefined) {
                            throw new runtime.RequiredError('inviteId', 'Required parameter requestParameters.inviteId was null or undefined when calling downloadTranscriptPdfByInviteIdFromHCPPatientWorkListController.');
                        }
                        queryParameters = {};
                        if (requestParameters.responseType !== undefined) {
                            queryParameters['responseType'] = requestParameters.responseType;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/hcp-pwl/me/invites/{inviteId}/transcript/pdf".replace("{".concat("inviteId", "}"), encodeURIComponent(String(requestParameters.inviteId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Downloads transcript pdf by invite id
     */
    HcpPwlMeApi.prototype.downloadTranscriptPdfByInviteIdFromHCPPatientWorkListController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.downloadTranscriptPdfByInviteIdFromHCPPatientWorkListControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get chart details of a single chart
     */
    HcpPwlMeApi.prototype.getChartDetailsFromHCPPatientWorkListControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgId === null || requestParameters.orgId === undefined) {
                            throw new runtime.RequiredError('orgId', 'Required parameter requestParameters.orgId was null or undefined when calling getChartDetailsFromHCPPatientWorkListController.');
                        }
                        if (requestParameters.chartId === null || requestParameters.chartId === undefined) {
                            throw new runtime.RequiredError('chartId', 'Required parameter requestParameters.chartId was null or undefined when calling getChartDetailsFromHCPPatientWorkListController.');
                        }
                        queryParameters = {};
                        if (requestParameters.withDataToPrefill !== undefined) {
                            queryParameters['withDataToPrefill'] = requestParameters.withDataToPrefill;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/hcp-pwl/me/orgs/{orgId}/charts/{chartId}".replace("{".concat("orgId", "}"), encodeURIComponent(String(requestParameters.orgId))).replace("{".concat("chartId", "}"), encodeURIComponent(String(requestParameters.chartId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.ChartDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get chart details of a single chart
     */
    HcpPwlMeApi.prototype.getChartDetailsFromHCPPatientWorkListController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getChartDetailsFromHCPPatientWorkListControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get invite by id
     */
    HcpPwlMeApi.prototype.getInviteByInviteIdFromHCPPatientWorkListControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.inviteId === null || requestParameters.inviteId === undefined) {
                            throw new runtime.RequiredError('inviteId', 'Required parameter requestParameters.inviteId was null or undefined when calling getInviteByInviteIdFromHCPPatientWorkListController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/hcp-pwl/me/invites/{inviteId}".replace("{".concat("inviteId", "}"), encodeURIComponent(String(requestParameters.inviteId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.InviteDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get invite by id
     */
    HcpPwlMeApi.prototype.getInviteByInviteIdFromHCPPatientWorkListController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getInviteByInviteIdFromHCPPatientWorkListControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Metadata about the practitioner directory structure
     */
    HcpPwlMeApi.prototype.getMyMetadataAsPractitionerFromHCPPatientWorkListControllerRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/hcp-pwl/me",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.UserInfoWithEmrEnabledResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Metadata about the practitioner directory structure
     */
    HcpPwlMeApi.prototype.getMyMetadataAsPractitionerFromHCPPatientWorkListController = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMyMetadataAsPractitionerFromHCPPatientWorkListControllerRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List PDS charts within an org that current user has access to. Optionally integrate with other systems
     */
    HcpPwlMeApi.prototype.listMyAccessibleChartsInAnOrgFromHCPPatientWorkListControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling listMyAccessibleChartsInAnOrgFromHCPPatientWorkListController.');
                        }
                        queryParameters = {};
                        if (requestParameters.sortDateAppointmentPretest !== undefined) {
                            queryParameters['sortDateAppointmentPretest'] = requestParameters.sortDateAppointmentPretest;
                        }
                        if (requestParameters.filterDateAppointmentPretest !== undefined) {
                            queryParameters['filterDateAppointmentPretest'] = requestParameters.filterDateAppointmentPretest;
                        }
                        if (requestParameters.filterInviteStatus) {
                            queryParameters['filterInviteStatus'] = requestParameters.filterInviteStatus.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.filterNccnCriteria) {
                            queryParameters['filterNccnCriteria'] = requestParameters.filterNccnCriteria.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.afterChart !== undefined) {
                            queryParameters['afterChart'] = requestParameters.afterChart;
                        }
                        if (requestParameters.count !== undefined) {
                            queryParameters['count'] = requestParameters.count;
                        }
                        if (requestParameters.dob !== undefined) {
                            queryParameters['dob'] = requestParameters.dob;
                        }
                        if (requestParameters.firstName !== undefined) {
                            queryParameters['firstName'] = requestParameters.firstName;
                        }
                        if (requestParameters.lastName !== undefined) {
                            queryParameters['lastName'] = requestParameters.lastName;
                        }
                        if (requestParameters.location !== undefined) {
                            queryParameters['location'] = requestParameters.location;
                        }
                        if (requestParameters.mrn !== undefined) {
                            queryParameters['mrn'] = requestParameters.mrn;
                        }
                        if (requestParameters.ordering !== undefined) {
                            queryParameters['ordering'] = requestParameters.ordering;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.startsWithSearch !== undefined) {
                            queryParameters['startsWithSearch'] = requestParameters.startsWithSearch;
                        }
                        if (requestParameters.numOrders !== undefined) {
                            queryParameters['numOrders'] = requestParameters.numOrders;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/hcp-pwl/me/orgs/{id}/charts".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.WorkListChartsListResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * List PDS charts within an org that current user has access to. Optionally integrate with other systems
     */
    HcpPwlMeApi.prototype.listMyAccessibleChartsInAnOrgFromHCPPatientWorkListController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listMyAccessibleChartsInAnOrgFromHCPPatientWorkListControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Re-sends an existing gia invite to a patient
     */
    HcpPwlMeApi.prototype.resendGiaInviteFromHCPPatientWorkListControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgId === null || requestParameters.orgId === undefined) {
                            throw new runtime.RequiredError('orgId', 'Required parameter requestParameters.orgId was null or undefined when calling resendGiaInviteFromHCPPatientWorkListController.');
                        }
                        if (requestParameters.chartId === null || requestParameters.chartId === undefined) {
                            throw new runtime.RequiredError('chartId', 'Required parameter requestParameters.chartId was null or undefined when calling resendGiaInviteFromHCPPatientWorkListController.');
                        }
                        if (requestParameters.inviteId === null || requestParameters.inviteId === undefined) {
                            throw new runtime.RequiredError('inviteId', 'Required parameter requestParameters.inviteId was null or undefined when calling resendGiaInviteFromHCPPatientWorkListController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/hcp-pwl/me/orgs/{orgId}/charts/{chartId}/invites/{inviteId}/resend".replace("{".concat("orgId", "}"), encodeURIComponent(String(requestParameters.orgId))).replace("{".concat("chartId", "}"), encodeURIComponent(String(requestParameters.chartId))).replace("{".concat("inviteId", "}"), encodeURIComponent(String(requestParameters.inviteId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.InviteDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Re-sends an existing gia invite to a patient
     */
    HcpPwlMeApi.prototype.resendGiaInviteFromHCPPatientWorkListController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resendGiaInviteFromHCPPatientWorkListControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Resolves specified notification
     */
    HcpPwlMeApi.prototype.resolveNotificationByChartFromHCPPatientWorkListControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.notificationId === null || requestParameters.notificationId === undefined) {
                            throw new runtime.RequiredError('notificationId', 'Required parameter requestParameters.notificationId was null or undefined when calling resolveNotificationByChartFromHCPPatientWorkListController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/hcp-pwl/me/notifications/{notificationId}".replace("{".concat("notificationId", "}"), encodeURIComponent(String(requestParameters.notificationId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.UserNotificationDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Resolves specified notification
     */
    HcpPwlMeApi.prototype.resolveNotificationByChartFromHCPPatientWorkListController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resolveNotificationByChartFromHCPPatientWorkListControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates and sends a gia invite to a patient
     */
    HcpPwlMeApi.prototype.sendGiaInviteFromHCPPatientWorkListControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgId === null || requestParameters.orgId === undefined) {
                            throw new runtime.RequiredError('orgId', 'Required parameter requestParameters.orgId was null or undefined when calling sendGiaInviteFromHCPPatientWorkListController.');
                        }
                        if (requestParameters.chartId === null || requestParameters.chartId === undefined) {
                            throw new runtime.RequiredError('chartId', 'Required parameter requestParameters.chartId was null or undefined when calling sendGiaInviteFromHCPPatientWorkListController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/hcp-pwl/me/orgs/{orgId}/charts/{chartId}/invites".replace("{".concat("orgId", "}"), encodeURIComponent(String(requestParameters.orgId))).replace("{".concat("chartId", "}"), encodeURIComponent(String(requestParameters.chartId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.InviteDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates and sends a gia invite to a patient
     */
    HcpPwlMeApi.prototype.sendGiaInviteFromHCPPatientWorkListController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendGiaInviteFromHCPPatientWorkListControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return HcpPwlMeApi;
}(runtime.BaseAPI));
exports.HcpPwlMeApi = HcpPwlMeApi;
/**
 * @export
 */
exports.DownloadReportPdfByIdFromHCPPatientWorkListControllerResponseTypeEnum = {
    Base64: 'base64',
    Binary: 'binary'
};
/**
 * @export
 */
exports.DownloadReportPdfByInviteIdFromHCPPatientWorkListControllerResponseTypeEnum = {
    Base64: 'base64',
    Binary: 'binary'
};
/**
 * @export
 */
exports.DownloadTranscriptPdfByIdFromHCPPatientWorkListControllerResponseTypeEnum = {
    Base64: 'base64',
    Binary: 'binary'
};
/**
 * @export
 */
exports.DownloadTranscriptPdfByInviteIdFromHCPPatientWorkListControllerResponseTypeEnum = {
    Base64: 'base64',
    Binary: 'binary'
};
/**
 * @export
 */
exports.ListMyAccessibleChartsInAnOrgFromHCPPatientWorkListControllerSortDateAppointmentPretestEnum = {
    Asc: 'asc',
    Desc: 'desc'
};
/**
 * @export
 */
exports.ListMyAccessibleChartsInAnOrgFromHCPPatientWorkListControllerFilterInviteStatusEnum = {
    Scheduled: 'scheduled',
    Created: 'created',
    Sent: 'sent',
    Opened: 'opened',
    Completed: 'completed',
    Resent: 'resent',
    Expired: 'expired',
    MissingContactInfo: 'missing_contact_info',
    LockedByProvider: 'locked_by_provider',
    LockedByVerifyUserFail: 'locked_by_verify_user_fail',
    PendingSend: 'pending_send'
};
/**
 * @export
 */
exports.ListMyAccessibleChartsInAnOrgFromHCPPatientWorkListControllerFilterNccnCriteriaEnum = {
    MeetsCriteria: 'meets_criteria',
    DoesNotMeetCriteria: 'does_not_meet_criteria',
    Na: 'na',
    MissingInfo: 'missing_info'
};
